import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";

export const useIsEstablishmentSet = (): number | undefined => {
    return useAppSelector(
        (state: RootState) => state.root.activeEstablishmentId,
    );
};
